import { Node, mergeAttributes } from "@tiptap/core";
import type { DOMOutputSpec } from "@tiptap/pm/model";

const Video = Node.create({
  name: "video",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      src: { default: null },
      controls: { default: true },
      uploadError: { default: null },
      uploading: { default: false },
      uploadProgress: { default: 0 },
      uploadFilename: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: "video" }];
  },

  renderHTML({ HTMLAttributes }) {
    const { uploadError, uploading, uploadProgress, uploadFilename, ...rest } =
      HTMLAttributes;
    const progressValue =
      typeof uploadProgress === "number"
        ? Math.min(1, Math.max(0, uploadProgress))
        : 0;
    const uploadLabel = uploadFilename
      ? `Uploading (${uploadFilename})...`
      : "Uploading...";
    const videoEl: DOMOutputSpec = [
      "video",
      mergeAttributes(rest, { controls: true, preload: "metadata" }),
    ];

    if (uploading) {
      const uploadingSpec: DOMOutputSpec = [
        "div",
        mergeAttributes(
          {
            class:
              "kb-media-wrapper kb-media-wrapper--video kb-video-uploading",
            "data-progress": Math.round(progressValue * 100),
          },
          this.options.HTMLAttributes
        ),
        ["div", { class: "kb-video-uploading__label" }, uploadLabel],
        [
          "div",
          { class: "kb-video-uploading__bar" },
          [
            "div",
            {
              class: "kb-video-uploading__bar-fill",
              style: `width: ${Math.round(progressValue * 100)}%;`,
            },
          ],
        ],
        [
          "div",
          { class: "kb-video-uploading__text" },
          `${Math.round(progressValue * 100)}%`,
        ],
      ];
      return uploadingSpec;
    }

    if (uploadError) {
      const uploadErrorSpec: DOMOutputSpec = [
        "div",
        mergeAttributes(
          {
            class: "kb-media-wrapper kb-media-wrapper--video",
            "data-upload-error": uploadError,
          },
          this.options.HTMLAttributes
        ),
        videoEl,
        [
          "div",
          { class: "kb-media-error" },
          uploadError || "Upload failed. Remove and try again.",
        ],
      ];
      return uploadErrorSpec;
    }

    return videoEl;
  },
});

export default Video;
